import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import "./card.scss"

const Card = ({ quote, rating = 0, subTitle, title }) => {
  const [expanded, setExpanded] = useState(false)
  const [needsToggle, setNeedsToggle] = useState(false)
  const quoteRef = useRef(null)

  useEffect(() => {
    const el = quoteRef.current
    if (!el) return

    const update = () => {
      const hasOverflow = el.scrollHeight > el.clientHeight + 1
      setNeedsToggle(prev => prev || hasOverflow)
    }

    update()

    let ro
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(update)
      ro.observe(el)
    } else {
      window.addEventListener("resize", update)
    }

    return () => {
      if (ro) ro.disconnect()
      else window.removeEventListener("resize", update)
    }
  }, [quote?.quote])

  const safeRating = Math.max(0, Math.min(5, Number(rating) || 0))
  const stars = Array.from({ length: safeRating }, (_, i) => (
    <span aria-hidden="true" className="star" key={i}>
      ★
    </span>
  ))

  const quoteId = `testimonial-quote-${(title || "item")
    .replace(/\s+/g, "-")
    .toLowerCase()}`

  return (
    <div className={`team-testimonial-card ${expanded ? "is-expanded" : ""}`}>
      {title && <div className="team-testimonial-card__title">{title}</div>}
      {subTitle && (
        <div className="team-testimonial-card__subtitle">{subTitle}</div>
      )}

      <div
        aria-label={`${safeRating} out of 5 stars`}
        className="team-testimonial-card__rating"
        role="img"
      >
        {stars}
      </div>

      <div
        className={`team-testimonial-card__quote ${
          expanded ? "expanded" : "clamped"
        }`}
        id={quoteId}
        ref={quoteRef}
      >
        {quote?.quote}
      </div>

      {needsToggle && (
        <button
          aria-controls={quoteId}
          aria-expanded={expanded}
          className="team-testimonial-card__toggle"
          onClick={() => setExpanded(v => !v)}
          type="button"
        >
          {expanded ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  )
}

Card.propTypes = {
  quote: PropTypes.shape({
    quote: PropTypes.string,
  }),
  rating: PropTypes.number,
  subTitle: PropTypes.string,
  title: PropTypes.string,
}

export default Card
